import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { G2S } from 'core/g2s';
import * as api from 'core/api';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component
export class PanelBannerComponent extends Vue {
    @Prop()
    displayArea: string;

    banners: api.Banner[] = [];

    mounted() {
        this.loadModel();
    }

    loadModel() {
        const bannerService = new api.BannerService();

        const request: api.BannerRequest = {
            displayArea: this.displayArea,
            departureDestinationId: undefined,
            arrivalDestinationId: undefined,
            validatingAirlineId: undefined
        };

        bannerService.list(request).then(
            (result: api.Banner[]) => {
                if (result && result.length > 0) {
                    this.banners = result;
                }
            }
        );
    }
}
